const Sucursal = ({onClick, locationName, address, telephone, whatsappLink, style, active = false}) => {

  const formatPhoneNumber = (phoneNumber) => {
    // Verifica si el número de teléfono contiene espacios
    if (!phoneNumber.includes(' ')) {
      // Formatea el número de teléfono si no tiene espacios
      return phoneNumber.replace(/(\d{2})(\d{4})(\d{4})/, '$1 $2 $3');
    }
    // Devuelve el número de teléfono sin cambios si ya contiene espacios
    return phoneNumber;
  }

  return (
    <a onClick={onClick} className={"sucursal row align-items-center m-0 " + (active ? 'active' : '')} style={style}>
      <div className="col p-0">
        <div className="sucursal-title">{locationName}</div>
        <div className="sucursal-address">{address}</div>
        {telephone ? <div>+54 {formatPhoneNumber(telephone)}</div> : whatsappLink ? <div>+{formatPhoneNumber(whatsappLink)}</div> : null}
      </div>
      {!whatsappLink && !telephone ? null :
        whatsappLink ?
          <div className="col-auto p-0">
            <a href={`https://wa.me/${whatsappLink}`} target="_blank" className="sucursal-icon whatsapp"></a>
          </div>
          :
          <div className="col-auto p-0">
            <a href={`tel://${telephone}`} target="_blank" className="sucursal-icon telephone"></a>
          </div>
      }
    </a>
  );
};

export default Sucursal;
